module.exports = __webpack_public_path__ + "static/media/tool_logo_insightVM.f0295560.png";